/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Tier1Inputs */

const en_coinvestments_tracking_tier1 = /** @type {(inputs: Coinvestments_Tracking_Tier1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tier`)
};

/**
* | output |
* | --- |
* | "Tier" |
*
* @param {Coinvestments_Tracking_Tier1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_tier1 = /** @type {((inputs?: Coinvestments_Tracking_Tier1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Tier1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_tier1(inputs)
});
export { coinvestments_tracking_tier1 as "coInvestments_tracking_tier" }